export class ImgConstants {
  public EPRINT_LOGO = "./assets/images/eprintit-logo-white-slogan.svg";
}

export const LOCAL_IMAGES = {
  eprintitLogo: './assets/images/eprintit-logo.png',
  emailWhite: './assets/images/email_white.png',
  picturesWhite: './assets/images/pictures_white.png',
  browserWhite: './assets/images/browser_white.png',
  dropboxWhite: './assets/images/dropbox_white.png',
  boxWhite: './assets/images/box_white.png',
  googleDriveWhite: './assets/images/google_drive_white.png',
  oneDriveWhite: './assets/images/one_drive_white.png',
  microsoftOfficeWhite: './assets/images/microsoft_office_white.png',
  iconPin: '/assets/images/icon_pin.png'
}